import { TransvirtualService } from './../../../../lib/integrations/transvirtual/transvirtual.service';
import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BookingsService } from '../bookings.service';
import { ToastrService } from 'ngx-toastr';
import { LocalStorage } from 'ngx-store';
import { Router, ActivatedRoute } from '@angular/router';
import { Url, User } from '../../../model/users.model';
import { Note } from '../../../model/notes.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConnoteDocuments,Rate } from 'src/app/model/connotedocuments.model';
import { FilesService } from '../../../services/files.service';
import { ImageResult } from 'ngx-image2dataurl';
import { NotificationService } from '../../../services/notification.service';
import { ComponentsSettingsService} from '../../../services/components_settings.service';

@Component({
  selector: 'app-connotedetails',
  templateUrl: './connotedetails.component.html',
  styleUrls: ['../../datatable.scss','./connotedetails.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [BookingsService, FilesService, NotificationService]
})

export class ConnoteDetailsComponent implements OnInit {
  @LocalStorage() url: Url;
  @LocalStorage() user: User;

  connoteId: number;
  id: number;
  connote: any = [];
  drivers: any = [];
  equipments: any = [];
  documents: any = [];
  job_notifications: any = [];
  sites: any = [];
  dispatch: any = [];
  dispatch_with_changeover: any = [];
  dispatches: any = [];
  driverTests: any = [];
  vehicleTests: any = [];
  packagings: any = [];
  packaging_types: any = [];
  history: any = [];
  sub: Subscription;
  units: number = 1; //default to 1 Load
  notes = [];
  note: Note;
  public frmNote: FormGroup;
  public modalRef: NgbModalRef;
  isEditMode: boolean = false;

  public frmJobFile: FormGroup;
  public jobFile: string;
  public jobFileName: any;
  public jobFileGroup: ConnoteDocuments;
  requiredFile: boolean = true;
  folder_name: any;

  spinner: boolean = false; 
  spinner2: boolean = false; 
  delete_id: any;
  documentation_file: any;
  loading_unloading: any;
  generated_diary: any;
  generated_pod: any;
  connote_file: any;
  runsheet: any;
  dg_file: any;
  diary: any;
  pod_app: any;
  pod_tms: any;
  ppd: any;
  document:any;
  customerslist: any;
  customer: any;
  has_customer_upload: boolean = false;
  has_driver_upload: boolean = false;
  has_admin_upload: boolean = false;
  doc_types :any=[];
  reference_no: string = '';

  public rateForm: FormGroup;

  public activityForm: FormGroup;
	public rate: Rate;

  public is_empty_run: boolean= false;
  public invoice_status: any;
  public is_invoice_ready: boolean = false;
  public currentId: number;
  public loadingIndicator2: boolean = false;
  load = 0;
  public totalPrice: number = 0;
  sp_appear :boolean = false;
  other_cost_details : string = '';
  addin_items : any= [];
  logview: any;
  retryClicked: boolean = false;
  showResponse: boolean = false;

  transvirtual_info: any = null;
  transvirtual_TipText: string = 'Transvirtual Connote';

  premise_types: any ;
  complete_addins: any ;
  enabledAddins: any = [];

  costDefaults: any;
  customer_costDefaults: any;


  @ViewChild('modalGenerate', { static: false }) modalGenerate: TemplateRef<any>;
  @ViewChild('modalRate',{ static: false }) modalRate: TemplateRef<any>;
  @ViewChild('modalNote',       { static: false }) modalNote:       TemplateRef<any>;
  @ViewChild('modalDeleteNote', { static: false }) modalDeleteNote: TemplateRef<any>;
  @ViewChild('modalAddFile',    { static: false }) modalAddFile:    TemplateRef<any>;
  @ViewChild('modalDeleteFile', { static: false }) modalDeleteFile: TemplateRef<any>;
  @ViewChild('modalMarkJobForInvoicing', { static: false }) modalMarkJobForInvoicing: TemplateRef<any>;
  @ViewChild('modalCustomer', { static: false }) modalCustomer: TemplateRef<any>;
  @ViewChild('modalActivity', { static: false }) modalActivity: TemplateRef<any>;
  @ViewChild('modelTVLogs', { static: false }) modelTVLogs: TemplateRef<any>;



  constructor(private _fb: FormBuilder, private fileService: FilesService, private bookingsService: BookingsService, private transvirtualService: TransvirtualService, private modal: NgbModal,
              private toastr: ToastrService,  private router: Router, private _Activatedroute: ActivatedRoute,  private svc_toaster: NotificationService,
              private svc_components : ComponentsSettingsService) { 
                  this.sub = this._Activatedroute.params.subscribe(params => { this.connoteId = params['id']; });
              }


  ngOnInit(): void {
    this.getConnoteDetails(this.connoteId);
    this.getConnoteNotes();

  }

  getConnoteDetails(connoteId) {
    this.resetDocChecker();
    this.bookingsService.getConnoteDetails(connoteId).subscribe( data => {     
      this.connote = data['connote'][0];
      this.initRateForm();
      this.drivers = data['drivers'];
      this.equipments = data['equipments'];
      this.sites = data['sites'];
      this.documents = data['documents'];
      this.job_notifications = data['job_notifications'];
      this.doc_types = data['doc_types'];
      this.packagings = data['packagings'];
      this.packaging_types = data['packaging_types'];
      this.addin_items = data['addin_items'];
      this.premise_types = data['premise_types'];
      this.complete_addins = data['complete_addins'];

      this.costDefaults = data['main_job_cost_defaults'];
      this.customer_costDefaults = data['customer_rates'];
      if(this.customer_costDefaults.length > 0){
        this.customer_costDefaults = this.customer_costDefaults[0];
      }

      //finalized customer cost defaults, if there is no value in main job cost defaults, get from customer rates
      this.changeCostDefaults();
      this.enabledAddins = this.complete_addins.filter(a => a.is_enabled == 1);

      this.documentation_file = [];
      this.loading_unloading = [];
      this.generated_diary = [];
      this.generated_pod = [];
      this.connote_file = [];
     
      this.runsheet = [];
      this.dg_file = [];
      this.diary = [];
      this.ppd = [];
      this.pod_app = [];
      this.pod_tms = [];

      if (data['dispatch'].length > 0){
        this.dispatch = data['dispatch'][0];
        this.dispatch_with_changeover = data['dispatch'];
        this.dispatches = data['dispatch'];
      }
      
      this.transvirtual_info = data['transvirtual_info'];
      if(this.transvirtual_info != null) this.sortTransvirtualLogs();

      if(Number(this.connote.work_hours) > 0){
        let temp = (Number(this.connote.work_hours)).toFixed(2);
        let string_hrs = (temp.toString()).split(".")
        
        if(string_hrs[1] != '00'){
          this.connote['drv_Hours'] = string_hrs[0] + " hrs " + (Number("."+string_hrs[1])*60) + " mins";
        } else this.connote['drv_Hours'] = string_hrs[0] + " hrs ";
      } else this.connote['drv_Hours'] = "0 hrs";

      this.checkDocuments(this.documents);
      this.getAmount(this.connote);

      // for (let doc of this.documents){

      //   if(doc.type_id == 1 && doc.driver_id != null && doc.user__id == null) {
      //     this.pod_app.push(doc);
      //   }
      //   if(doc.type_id == 1 && doc.user__id != null && doc.driver_id == null) {
      //     this.pod_tms.push(doc);
      //   }
      //   if(doc.type_id == 5 ) {
      //     this.loading_unloading.push(doc);
      //   }
      //   if(doc.type_id == 6 && doc.user__id != null) {
      //     this.diary.push(doc);
      //   }
      //   if(doc.type_id == 7 && doc.user__id != null) {
      //     this.generated_diary.push(doc);
      //   }
      //   if(doc.type_id == 8 && doc.user__id != null) {
      //     this.generated_pod.push(doc);
      //   }
      //   if(doc.type_id == 9 && doc.user__id != null) {
      //     this.connote_file.push(doc);
      //   }
      //   if(doc.type_id == 10 && doc.user__id != null) {
      //     this.dg_file.push(doc);
      //   }
      //   if(doc.type_id == 11 && doc.user__id != null) {
      //     this.documentation_file.push(doc);
      //   }
      //   if(doc.type_id == 12 && doc.user__id != null) {
      //     this.ppd.push(doc);
      //   }
      //   if(doc.type_id == 13 && doc.user__id != null) {
      //     this.runsheet.push(doc);
      //   }
      // }

      
      this.driverTests = data['driver_tests'];
      this.vehicleTests = data['vehicle_tests'];
      this.history = data['history'];
      if (this.connote.charging_method_id == 2)
        this.units = this.connote.pallet;
      else if (this.connote.charging_method_id == 3)
        this.units = this.connote.weight / 1000;

      if(this.sites.length > 0){
        this.sites.forEach(el => {
          let temp = this.history.filter(x=> x.run_action_id == el.run_action_id && x.connote_site_id == el.id);

          if(temp == null){
            el['is_done'] = false;
          }else if(temp == undefined){
            el['is_done'] = false;
          }else if(temp.length == 0){
            el['is_done'] = false;
          }else{
            el['is_done'] = true;
          }
        });
      }
      console.log('connote', data);

      if(this.connote['run_type_id']==3){
        this.is_empty_run = true;
      }else{
        this.is_empty_run = false;
      };

      if (this.connote) {
        if (this.connote['is_invoiced'] == 0){
          this.invoice_status = 'Not Yet Invoiced';

          if(this.connote['is_invoiced'] == 0 && this.connote['is_invoice_ready'] == 1){
            this.invoice_status = 'Ready for Invoice';
          }
        } 
        else{
          this.invoice_status = 'Invoiced';
        }
      }
      else{
        this.invoice_status = 'Not Yet Invoiced';
      } 
      
      this.is_invoice_ready = this.connote['is_invoice_ready'];

      if(this.connote['special_instructions'] == '' || this.connote['special_instructions'] == null){
        this.sp_appear = true;
        this.sp_instructions = '';
      }else{
        this.sp_appear = false;
        this.sp_instructions = this.connote['special_instructions'];
      }
      this.other_cost_details = '';
      if(this.addin_items.length > 0 ){
        this.addin_items.forEach(ai => {
          this.other_cost_details = this.other_cost_details + '[' + ai.addin_label + ': $' + ai.cost + '] '
        });
      }
    
    });

    
  }

checkDocuments(documents){
  for (let doc of documents){
    if(doc.role == 'Administrator' || doc.role == 'Super Administrator'){
      this.has_admin_upload = true;
    }

    if(doc.role == 'Driver'){
      this.has_driver_upload = true;
    }

    if(doc.role == 'Customer'){
      this.has_customer_upload = true;
    }
  }
}

initRateForm() {
 const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{1,2})?$';
 const floatRegex = '^[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$';

 this.rateForm = this._fb.group({
     connote_id    : [''],
     price         : ['', [Validators.required, Validators.pattern(currencyRegex)]],
     service_fee   : ['', [Validators.required, Validators.pattern(floatRegex)]],
     fuel_levy     : ['', [Validators.required, Validators.pattern(floatRegex)]],
     total_cost    : [''],
     pallet        : [0, Validators.pattern(floatRegex)],
     tonnes        : [0, Validators.pattern(floatRegex)],
     user_id       : [this.user.id]  
 });

 this.rateForm.addControl('connote_addins', this._fb.array([]));

 this.patchRateFormValue(this.connote);
}

patchRateFormValue(connote){
   this.rateForm.controls.connote_id.setValue(connote.id);
     this.rateForm.controls.price.setValue(connote.price);
     this.rateForm.controls.fuel_levy.setValue(connote.fuel_levy);
     this.rateForm.controls.service_fee.setValue(connote.service_fee);
     this.rateForm.controls.total_cost.setValue(connote.total_cost);
     this.rateForm.controls.pallet.setValue(connote.pallet);
     this.rateForm.controls.tonnes.setValue(connote.tonnes);

     const addinsArray = this.rateForm.get('connote_addins') as FormArray;
     addinsArray.clear();
     this.addin_items.forEach(addin => {
       const completeAddin = this.complete_addins.find(ca => ca.connote_addin_id == addin.connote_addin_id);
       addinsArray.push(this._fb.group({
         id: [addin.id],
         addin_id: [addin.connote_addin_id],
         cost: [addin.cost],
         is_enabled: [completeAddin ? completeAddin.is_enabled : 0],
         addin_label: [completeAddin ? completeAddin.label : addin.addin_label]
       }));
     });
 }

openModalRate(rate: Rate): void {
  if (rate) {
    this.isEditMode = true;
    this.patchRateFormValue(rate);
  }

  this.modalRef = this.modal.open(this.modalRate, { size: 'md', backdrop:'static'});
}
  
async onSubmitRate(rate: Rate){
  this.spinner = true;
  rate.total_cost = parseFloat(this.recomputeTotalCost(rate));
  
  await this.bookingsService.updateRate(rate).toPromise().then(data => {
    this.toastr.success('', data['message'], {
      timeOut: 5000,
      positionClass: 'toast-top-full-width',
      progressBar: true
    });
    if(this.connote.run_type_id == 2){
    //this.spinner = false; 
    this.closeModal();
    this.load = 1;
    this.generateDocument();
    }
    else{
      //this.spinner = false;
      this.closeModal();
      this.getConnoteDetails(this.connoteId);
    }

  }, error => {
      this.toastr.error("Please try again.", "There was a problem with updating the selected rate", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
  });

  this.spinner = false;
}

resetDocChecker(){
  this.has_admin_upload = false;
  this.has_driver_upload = false;
  this.has_customer_upload = false;
}

showConnotesPage() {
  this.router.navigate(['bookings/list']);
}

public formatDate(inDate: string) {
  let formatedDate: Date;
  if (inDate && !inDate.includes('0000')) {
    formatedDate = new Date(inDate.replace(/-/g, "/"));
    return formatedDate;
  }
  else return null;
}

public isset(object){
  return (typeof object !=='undefined');
}

  public initForms() {
    this.frmNote = this._fb.group({
      id:          [''],
      updated_by:  [''],
      connote_id:  [this.connoteId],
      user_id:     [this.user.id],
      text:        ['', Validators.required]
    });
  }

  public addFileFormGroup() {
    this.frmJobFile = this._fb.group({
      id:                       [''],
      connote_id:               this.connote['id'],
      description:              '',
      file:                     ['', Validators.required],
      connote_document_type_id: ['', Validators.required],
      user_id:                  this.user.id,
    });
  }

  filename: string;

  getJobFile(event) {
    const fileCtrl = (<any>this.frmJobFile).controls.file;
    let allowedExtension = ['pdf','png','jpg','gif'];

    if (event == '' || event == null) {
      fileCtrl.setValue(event);
      this.requiredFile = false;
    }
    else{
      let selectedFilename = event.file.name.split('.');
      let selectedFileExtension = selectedFilename[selectedFilename.length - 1].toLowerCase();
      console.log('selected file: ',selectedFilename);

      if( allowedExtension.includes(selectedFileExtension) ){
        this.requiredFile = true;
        let file: ImageResult;
        file = event;
        this.jobFile = event;
        this.filename = file.file.name;
        fileCtrl.setValue(file.file.name);
      }
      else{
        this.toastr.error('','Error: Extension Not Allowed', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true,
        });

        let modal = document.getElementsByClassName('modal-body')[0];
        let fileForm = modal.children[2].children[0].children[0];
        let appFileUploader = fileForm.children[1];
        let fileInput_name = appFileUploader.children[0][1];

        fileInput_name.value = '';
      }
    }
  }

  openModalAddFile(): void {
    this.addFileFormGroup();
    this.modalRef = this.modal.open(this.modalAddFile, { backdrop: 'static'});
  }

  openDeleteFile(jFile) {
    this.delete_id = jFile
    this.modalRef = this.modal.open(this.modalDeleteFile, {backdrop:'static'});
  }

  async deleteFile(jobFile) {  
    
    this.spinner = true;
    await this.bookingsService.deleteJobFile(jobFile.id).toPromise().then(data => {
      this.toastr.success('', data["message"], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });

      this.fileService.s3deletefile(jobFile.folder, jobFile.file).toPromise().then(data => { });//delete file  
      this.modal.dismissAll();
      this.ngOnInit()
    }, error => {
      this.toastr.error("Please try again.", "There was a problem with deleting the selected file", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    })
    this.spinner = false;
  }



  public onSubmitJobFile(jobFile: ConnoteDocuments): void {
    this.spinner = true;
    if (this.frmJobFile.valid) {
      this.jobFileGroup = jobFile;
      this.jobFileGroup.connote_id = this.connoteId;
      this.jobFileGroup.user_id = this.user.id;

      let folder = this.getFolderName(jobFile.connote_document_type_id);

      this.fileService.uploadRawFileWithRename(folder, this.jobFile, this.filename)
        .subscribe(result => {
          this.jobFileName = {
            filename:                   result['data'],
            connote_id:                 this.connoteId,
            user_id:                    this.user.id,
            connote_document_type_id:   jobFile.connote_document_type_id,
            description:                jobFile.description,
          };

          if(result['data']){
            this.bookingsService.createAdminUpload(this.jobFileName).subscribe(jobFile => {
              this.toastr.success('', jobFile["message"], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
              this.modal.dismissAll();
              this.ngOnInit()
            }, error => {
              this.toastr.error("Please try again.", "There was a problem with uploading the selected file", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
              this.ngOnInit();
            });
            this.spinner= false;
            this.closeModal();
           
          }else{
            this.toastr.error("Please try again.", "There was a problem with uploading the selected file", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
            this.spinner= false;
            this.closeModal();
          }
          
        });
    };

   
  }

  getFolderName(doc_type: number):string{
    let folder_name = "connote_documents";
      if(doc_type !==null || doc_type !=0){
        this.doc_types.forEach(dtype => {
          if(dtype.id == doc_type){
            folder_name = dtype.folder;
          }
        });
      };
    return folder_name;
  }

  // Notes
  getConnoteNotes() {
    this.bookingsService.getConnoteNotes(this.connoteId).subscribe(data => {
      this.notes = data['notes'];
    });
  }

  public createConnoteNote(note: Note) {
    this.bookingsService.createConnoteNote(note).subscribe(data => {
    });
  }

  public updateConnoteNote(note: any) {
    this.bookingsService.updateConnoteNote(note).subscribe(data => {
      this.toastr.success('', data['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });

      this.getConnoteNotes();

    }, error => {
        this.toastr.error("Please try again.", "There was a problem with updating the selected note", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
    });
  }

  public deleteConnoteNote(id: number) {
    this.bookingsService.deleteConnoteNote(id).subscribe(data => {
      this.toastr.success('', data['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
      this.getConnoteNotes();
    }, error => {
        this.toastr.error("Please try again.", "There was a problem with deleting the selected note", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });
    this.closeModal();
  }

  public closeModal() {
    this.modalRef.close();
  }

  openModalNote(note: Note): void {
    this.initForms();

    if (note) {
      this.isEditMode = true;
      this.frmNote.controls.id.setValue(note.id);
      this.frmNote.controls.text.setValue(note.text);
      this.frmNote.controls.updated_by.setValue(note.updated_by);
    } 

    else {
      this.isEditMode = false;
      this.frmNote.controls.id.setValue(null);
    };

    this.modalRef = this.modal.open(this.modalNote, {backdrop:'static'});
  }

  openModalDeleteNote(note: Note): void {
    if (note) {
      this.note = note;
    }
    this.modalRef = this.modal.open(this.modalDeleteNote, { size: 'sm' , backdrop: 'static'});
  }

  onSubmitNote(note: Note): void {
    this.note = note;

    if (this.frmNote.valid) {
      this.note = note;

      if (note.id) {
        this.note.updated_by = JSON.parse(localStorage.getItem('ngx_user')).id;
        this.updateConnoteNote(this.note);
      }
      else {
        this.bookingsService.createConnoteNote(note).subscribe(data => {
          this.toastr.success('', data['result'], {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
          this.getConnoteNotes();
        }, error => {
            this.toastr.error("Please try again.", "There was a problem with creating the selected note", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          });
      }
      this.closeModal();
    }
  }

  public onDeleteNote(id: number) {
    this.bookingsService.deleteConnoteNote(id).subscribe(data => {
      this.toastr.success('', data['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });

      this.getConnoteNotes();

      }, error => {
        this.toastr.error("Please try again.", "There was a problem with deleting the selected note", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });
    this.closeModal();
  }

  public viewDispatch(id){
    if(this.isEnabled('Local Manifest') || this.isEnabled('Linehaul Manifest')){
      const openIn = this.router.serializeUrl(
        this.router.createUrlTree(['/dispatch/manifestdetails/', id ])
      );
      window.open(openIn, '_blank');
    }
  }

  async openModalCustomer(){
    this.reference_no = this.connote.customer_reference_no;
    this.spinner2 = true;
    this.bookingsService.getCustomerSelection().toPromise().then(data => {
      let customerslist_temp = [];
      if(this.connote.customer_deleted_date != null){
        customerslist_temp = data['customers'].filter(data => { return data.deleted_date == null || data.id == this.connote.customer_id });
        this.customerslist = customerslist_temp;
      }
      else{
        customerslist_temp = data['customers'].filter(data => { return data.deleted_date == null });
        this.customerslist = customerslist_temp;
      }
      this.customer = this.connote.customer_id;
      this.spinner2 = false;
    });
    this.modalRef = this.modal.open(this.modalCustomer, { size: 'xs', backdrop: 'static'});
  }
  
  updateCustomer(){
    console.log('Updating Customer Details');
    this.spinner = true;
    let data = {
        'id': this.connote.id,
        'customer_id': this.customer,
        'customer_reference_no': this.reference_no,
        'user_id': this.user.id
    }
    this.bookingsService.updateRefNo(data).subscribe(data => {
      if(data['error'] == false){
        this.toastr.success('', data['message'], { timeOut: 5000,positionClass: 'toast-top-full-width', progressBar: true});
      } else this.toastr.error('', data['message'], { timeOut: 5000,positionClass: 'toast-top-full-width', progressBar: true});
      this.spinner = false;
      this.load = 1;
      this.getConnoteDetails(this.connoteId);
      this.getConnoteNotes();
      this.generateDocument();
      this.modal.dismissAll();
    }, error => {
      this.toastr.error("", "There was a problem with updating the selected connote's Reference No.. Please try again.", {
        timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true });
      this.modal.dismissAll();
    });
    
  }

  openModalMarkForInvoice(id: number): void {
    this.currentId = id;
    this.modalRef = this.modal.open(this.modalMarkJobForInvoicing, { backdrop: 'static'});
  }

  public onMarkJobForInvoicing(id: number): void {
    this.loadingIndicator2 = true;
    this.bookingsService.markForInvoicing(id, this.user.id).subscribe(data => {
      this.toastr.success('', 'Successfully marked the connote for invoicing.', {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
      this.getConnoteDetails(this.connoteId);
      setTimeout(() => { this.loadingIndicator2 = false; }, 1500);

    }, error => {
      this.toastr.error("", "There was a problem with marking the selected connote for invoicing. Please try again.", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });

    this.closeModal();
  }

  public openGenerateDocument(type){
    this.document = type;
    this.modalRef = this.modal.open(this.modalGenerate, { size: 'xs', backdrop: 'static' });
  }

  async generateDocument(){
    console.log('File',this.document)
    if (this.load>0){
      setTimeout(() => { this.loadingIndicator2 = true; })
    }
    else{
      this.spinner = true;
    }

    if(this.document == undefined){
      this.document = "Connote File"
    }

    if(this.document == 'Connote File' || this.document == 'PPD'){
      if(this.sites.length == 1){
        await this.bookingsService.generateLocalStartConnote(this.connote.id,null).toPromise().then(data=>{
          if(data['error'] !=true){
            this.toastr.success('', 'Successfully generated '+ this.document, {
              timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
            });
            this.getConnoteDetails(this.connoteId);;
          } else {
            this.toastr.error('', "Error in generating " + this.document, {
              timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
            });
          }
        }, err =>{
          this.toastr.error("Please try again.", "Error in generating " + this.document, {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });

        if (this.load>0){
          setTimeout(() => { this.loadingIndicator2 = false;
          this.load = 0; })
        }
        else{
          this.spinner = false;
        }
        this.closeModal();
      }
      else{
        await this.bookingsService.generateProcessingConnotesDoc(this.connote.id,null).toPromise().then(data=>{
          if(data['error'] !=true){
            this.toastr.success('', 'Successfully generated '+ this.document, {
              timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
            });
            this.getConnoteDetails(this.connoteId);;
          } else {
            this.toastr.error('', "Error in generating " + this.document, {
              timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
            });
          }
        }, err =>{
          this.toastr.error("Please try again.", "Error in generating " + this.document, {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });

        if (this.load>0){
          setTimeout(() => { this.loadingIndicator2 = false;
          this.load = 0; })
        }
        else{
          this.spinner = false;
        }
        this.closeModal();
      }
    }
    else if(this.document == 'Packaging Label'){
      await this.bookingsService.createPackagingLabel(this.connote.id).toPromise().then(data=>{
        if(data['error'] !=true){
          this.toastr.success('', 'Successfully generated '+ this.document, {
            timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
          });
          this.getConnoteDetails(this.connoteId);;
        } else {
          this.toastr.error('', "Error in generating " + this.document, {
            timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
          });
        }
      }, err =>{
        this.toastr.error("Please try again.", "Error in generating " + this.document, {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });

      if (this.load>0){
        setTimeout(() => { this.loadingIndicator2 = false;
        this.load = 0; })
      }
      else{
        this.spinner = false;
      }
      this.closeModal();
    }
  
  }

  getAmount(row){
    let units = 1;
    let work_hours = Number(this.connote.work_hours)
    if (row.charging_method == 'Tonne'){
      row.tonnes!=0? units = row.tonnes :units = 1;
    } else if (row.charging_method == 'Pallet'){
      row.pallet!=0? units = row.pallet: units = 1;
    } else if (row.charging_method == 'Load'){
      row.loads!=0?units = row.loads: units = 1;
    }  else if (row.charging_method == 'Hourly') {
        if (work_hours > 0) units = work_hours;
    }
    // else {
    //     if (row.total_klms > 0)
    //       units = row.total_klms;
    //     // else units = 0;
    // }
    let basicCost = units * row.price;
    let fuelLevyvalue = (parseFloat(row.fuel_levy) * basicCost) / 100;  // add fuel levy
    let serviceFeeValue = (parseFloat(row.service_fee) * basicCost) / 100;   // subtract service fee
    this.totalPrice = basicCost + fuelLevyvalue - serviceFeeValue;
  }

  public CHARGING_METHOD_ID = {
    TONNE: '1',
    PALLETS: '2',
    LOAD: '3',
    HOURLY: '4',
    DISTANCE: '5'
  };

  getUnits(charging_method_id){
    var units = 0;
    switch(charging_method_id.toString()){
      case this.CHARGING_METHOD_ID.TONNE : {
        if((this.rateForm.controls.tonnes.value > 0 && this.rateForm.controls.tonnes.touched) && (this.rateForm.controls.tonnes.value != this.connote.tonnes)){
          units = this.rateForm.controls.tonnes.value;
        }else if(this.connote.tonnes > 0){
          units = this.connote.tonnes
        }else{
          units = 1;
        };break;
      };
      case this.CHARGING_METHOD_ID.PALLETS : {
        if((this.rateForm.controls.pallet.value > 0 && this.rateForm.controls.pallet.touched) && (this.rateForm.controls.pallet.value != this.connote.pallet)){
          units = this.rateForm.controls.pallet.value;
        }else if(this.connote.pallet > 0){
          units = this.connote.pallet;
        }else if(this.getPalletPackagingUnits() > 0){
          units = this.getPalletPackagingUnits();
        }else{
          units = 1;
        };break;
      };
      case this.CHARGING_METHOD_ID.LOAD : {
        if(this.connote.loads > 0){
          units = this.connote.loads
        }else{
          units = 1;
        };break;
      };
      case this.CHARGING_METHOD_ID.HOURLY : {
        if(this.connote.est_total_hours > 0){
          units = this.connote.est_total_hours
        }else{
          units = 1;
        };break;
      };
      case this.CHARGING_METHOD_ID.DISTANCE : {
        if(this.connote.total_klms > 0){
          units = this.connote.total_klms
        }else{
          units = 1;
        };break;

      };
      default : {units = 0; break;};
    }
    
    return units;
  };

  getPackagingTypeById(packaging_type_id){
    var p_type = '';
    this.packaging_types.forEach(item =>{
      if(packaging_type_id == item.id){
        p_type = item.name;
      };
    });

    return p_type;
  }

  getPalletPackagingUnits(){
    var pallet_units = 0;
    this.packagings.forEach(packaging=>{
      if(this.getPackagingTypeById(packaging.packaging_type_id) == 'pallet'){
        pallet_units += packaging.quantity;
      }
    });

    return pallet_units;
  }

  getTotalCost(){
    var cost = 0;
    if(this.connote.total_cost>0){
      cost = this.connote.total_cost;
    }else{

      if(this.connote.price > 0){
        let basicCost = this.getUnits(this.connote.charging_method_id) * this.connote.price;
        let fuelLevyvalue = (parseFloat(this.connote.fuel_levy) * basicCost) / 100;  // add fuel levy
        cost = basicCost + fuelLevyvalue + this.connote.other_cost;

        let serviceFeeValue = (parseFloat(this.connote.service_fee) * basicCost) / 100;   // subtract service fee
        cost = cost - serviceFeeValue;
      };

    }

    return cost.toFixed(2);
  }

  recomputeTotalCost(new_rate){
    var cost = 0;
    let basicCost = this.getUnits(this.connote.charging_method_id) * new_rate.price;
    let fuelLevyvalue = (parseFloat(new_rate.fuel_levy) * basicCost) / 100;  // add fuel levy
    cost = basicCost + fuelLevyvalue + this.getCurrentOtherCost();

    let serviceFeeValue = (parseFloat(new_rate.service_fee) * basicCost) / 100;   // subtract service fee
    cost = cost - serviceFeeValue;

    return cost.toFixed(2);
  }

  checkIntValue(int_value, caller){

    switch(caller){
      case 'service_fee' :{
        if(int_value.target.value > 100){ this.rateForm.controls.service_fee.setValue(100);}
        if(int_value.target.value < 0){ this.rateForm.controls.service_fee.setValue(0);}
        break;
      }
      case 'fuel_levy' :{
        if(int_value.target.value > 100){ this.rateForm.controls.fuel_levy.setValue(100);}
        if(int_value.target.value < 0){ this.rateForm.controls.fuel_levy.setValue(0);}
        break;
      }
      case 'price' :{
        if(int_value.target.value < 0){ this.rateForm.controls.price.setValue(0);}
        break;
      }
      default:break;
    }

  }

  addAddin(addin) {
    const addinsArray = this.rateForm.get('connote_addins') as FormArray;
    addinsArray.push(this._fb.group({
      id: [null],
      addin_id: [addin.connote_addin_id],
      cost: [0],
      is_enabled: [addin.is_enabled],
      addin_label: [addin.label]
    }));
  }

  removeAddin(index) {
    const addinsArray = this.rateForm.get('connote_addins') as FormArray;
    addinsArray.removeAt(index);
  }

  addNewAddin(addinId, cost) {
    if (!addinId || !cost || cost <= 0) return;
    const addin = this.complete_addins.find(a => a.id == addinId);
    if (addin) {
      this.addAddin(addin);
      const addinsArray = this.rateForm.get('connote_addins') as FormArray;
      const last = addinsArray.at(addinsArray.length - 1);
      last.get('cost').setValue(parseFloat(cost));
    }
  }

  getCurrentOtherCost() {
    const addinsArray = this.rateForm.get('connote_addins') as FormArray;
    return addinsArray.controls.reduce((sum, control) => sum + (parseFloat(control.get('cost').value) || 0), 0);
  }

  get connoteAddins(): FormArray {
    return this.rateForm.get('connote_addins') as FormArray;
  }

  get availableAddins() {
    return this.enabledAddins.filter(addin =>
      !this.connoteAddins.controls.some(control => control.get('addin_id').value == addin.connote_addin_id)
    );
  }

  selectedAddin: string = '';
  selectedCost: number = 0;

  getFormTotalCost() {
    let basicCost = this.getUnits(this.connote.charging_method_id) * this.rateForm.value.price;
    let fuelLevyvalue = (parseFloat(this.rateForm.value.fuel_levy) * basicCost) / 100;
    let serviceFeeValue = (parseFloat(this.rateForm.value.service_fee) * basicCost) / 100;
    let otherCost = this.getCurrentOtherCost();
    return (basicCost + fuelLevyvalue - serviceFeeValue + otherCost).toFixed(2);
  }

  sp_instructions: string = '';
  updateSpecialInstructions(){
    this.sp_instructions.trim();
    this.bookingsService.updateSpecialInstructions(this.sp_instructions, this.connoteId).subscribe(data=>{
      if(data['error']){
        this.svc_toaster.showError(data['message'], "Update Connote Error");
      }else{
        this.svc_toaster.showSuccess(data['message'], "Update Connote Success");
        this.getConnoteDetails(this.connoteId);
      };

      this.sp_appear = false;
    });

  }

  initActivityForm(){
    this.activityForm = this._fb.group({
        index           : [''],
        id              : [''],
        notes           : [''],
        contact_name    : [''],
        contact_no      : [''],
        contact_email   : [''],
  });
  }
  editActivity(s, i){
    this.initActivityForm();
    this.activityForm.patchValue(s)
    this.activityForm.get('index').setValue(i)
    this.modalRef = this.modal.open(this.modalActivity, { size: 'xs', backdrop: 'static'});
  }

  async onsubmitActivities(row){
    this.spinner = true
  
    await this.bookingsService.updateConnoteSites(row).toPromise().then(data => {
       setTimeout(() => { 
        if(this.connote.run_type_id == 1 || this.connote.run_type_id == 2){
          this.bookingsService.generateProcessingConnotesDoc(this.connoteId,null).subscribe(res => {});
        }
        
        this.toastr.success('', data['message'], {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        
        this.getConnoteDetails(this.connoteId);
        this.spinner = false;
        this.closeModal();
      }   ,1500);
    
      }, error => {
        this.toastr.error("Please try again.", "There was a problem with updating this activity", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
        this.spinner = false;
        this.closeModal();
      });
    }

  transvirtualStatus(){
    let status: number;
    
    if(this.transvirtual_info.isActive){
      (this.transvirtual_info.hasFailedLogs)? status = 3 : status = 1;
    } else status = 2;

    return status;
  }

  transvirtualTooltip(){
    let message:string;

    if(this.transvirtualStatus() == 1) message = "This connote is synced to Customer's Transvirtual Account."
    else if(this.transvirtualStatus() == 2) message= "Connote updates are not synced. Customer's Transvirtual Account is disabled."
    else if(this.transvirtualStatus() == 3) message = "Some updates to Transvirual failed to sync."

    return message;
  }

  private sortTransvirtualLogs(){
    let status_logs = [], compiled_status, new_logs = [];

    if(this.transvirtual_info.transvirtual_logs.length > 0){
      status_logs = this.transvirtual_info.transvirtual_logs.filter(x=>x.request_type_id == 2);
      new_logs = this.transvirtual_info.transvirtual_logs.filter(x=>x.request_type_id != 2);

      compiled_status = status_logs[status_logs.length-1];
      compiled_status.new_retry_times = compiled_status.retry_times;
      compiled_status.previous_logs = [];

      status_logs.forEach(el => {
        if(el.id != compiled_status.id){
          compiled_status.new_retry_times = compiled_status.new_retry_times + el.retry_times;
          compiled_status.previous_logs.push(el);
          }
      });

      new_logs.push(compiled_status);
      
      new_logs.sort(function(a,b){
        var dateA = new Date(b.updated_at).valueOf(), dateB = new Date(a.updated_at).valueOf()
        return dateB - dateA || a.id - b.id});
    }

    this.transvirtual_info.transvirtual_logs = new_logs;
    this.checkFailedLogs(this.transvirtual_info.transvirtual_logs.filter(x=>x.status_code != 200).length);
  }

  private checkFailedLogs(count:number){(count > 0)? this.transvirtual_info.hasFailedLogs = true: this.transvirtual_info.hasFailedLogs = false;}

  showResponseJson(){ (this.showResponse)? this.showResponse = false: this.showResponse = true;}

  openTransvirtualModal(log){
    this.logview = log;
    this.showResponse = false;
    this.modalRef = this.modal.open(this.modelTVLogs, { size: 'xs', backdrop: 'static', centered :true});
  }

  retryTransvirtualUpdate(log){
    let payload = this.getPayload(log);

    this.retryClicked = true;
    this.transvirtualService.retryRequest(payload).toPromise().then(async data => {
      await this.getConnoteDetails(this.connoteId);

      if(data['message'] == ""){
        this.toastr.info("", "Transvirtual responded with: " + data['response']['StatusText'], {
          timeOut: 5000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      } else {
        this.toastr.info("", "Transvirtual responded with: " + data['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }

      this.modal.dismissAll();
      this.retryClicked = false;
    }, error => {
      this.toastr.error("", "There was a problem with sending the request.", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
      console.log(error);
      this.modal.dismissAll();
      this.retryClicked = false;
    });
  }

  private getPayload(log){
    return {
      'id': log.id,
      'http_method': log.http_method,
      'request_path': log.request_path,
      'request_body': log.request_body,
      'retry_times': log.retry_times, 
      'transv_account_id':this.transvirtual_info.transvirtual_account_id,
      'transv_customer_id': this.transvirtual_info.transvirtual_customer_id,
    }
  }

  isEnabled(name){
		let is_enabled = false;
		is_enabled = this.svc_components.isComponentEnabled(name);
		return is_enabled
	}

  hr_waiting_time:number = 0;
  semi_waiting_time:number = 0;
  bdbl_waiting_time:number = 0;
  changeCostDefaults(){
    if(this.customer_costDefaults['tail_lift_per_pallet'] != null){this.costDefaults.tail_lift_per_pallet = this.customer_costDefaults['tail_lift_per_pallet'];};
    if(this.customer_costDefaults['hand_unload_per_pallet'] != null){this.costDefaults.hand_unload_per_pallet = this.customer_costDefaults['hand_unload_per_pallet'];};
    if(this.customer_costDefaults['extra_pickup_delivery'] != null){this.costDefaults.extra_pickup_delivery = this.customer_costDefaults['extra_pickup_delivery'];};
    if(this.customer_costDefaults['dg_packed'] != null){this.costDefaults.dg_packed = this.customer_costDefaults['dg_packed'];};
    if(this.customer_costDefaults['dg_bulk'] != null){this.costDefaults.dg_bulk = this.customer_costDefaults['dg_bulk'];};
    if(this.customer_costDefaults['bdbl_split_per_site'] != null){this.costDefaults.bdbl_split_per_site = this.customer_costDefaults['bdbl_split_per_site'];};
    if(this.customer_costDefaults['hr_demurrage_per_hour'] != null){this.costDefaults.hr_demurrage_per_hour = this.customer_costDefaults['hr_demurrage_per_hour'];};
    if(this.customer_costDefaults['semi_demurrage_per_hour'] != null){this.costDefaults.semi_demurrage_per_hour = this.customer_costDefaults['semi_demurrage_per_hour'];};
    if(this.customer_costDefaults['bdbl_demurrage_per_hour'] != null){this.costDefaults.bdbl_demurrage_per_hour = this.customer_costDefaults['bdbl_demurrage_per_hour'];};
    if(this.customer_costDefaults['futile_per_pallet'] != null){this.costDefaults.futile_per_pallet = this.customer_costDefaults['futile_per_pallet'];};
    if(this.customer_costDefaults['extra_crew_per_pallet'] != null){this.costDefaults.extra_crew_per_pallet = this.customer_costDefaults['extra_crew_per_pallet'];};
    if(this.customer_costDefaults['residential_per_site'] != null){this.costDefaults.residential_per_site = this.customer_costDefaults['residential_per_site'];};
    if(this.customer_costDefaults['after_hours_per_site'] != null){this.costDefaults.after_hours_per_site = this.customer_costDefaults['after_hours_per_site'];};
    if(this.customer_costDefaults['hr_overnight_holding'] != null){this.costDefaults.hr_overnight_holding = this.customer_costDefaults['hr_overnight_holding'];};
    if(this.customer_costDefaults['semi_overnight_holding'] != null){this.costDefaults.semi_overnight_holding = this.customer_costDefaults['semi_overnight_holding'];};
    if(this.customer_costDefaults['bdbl_overnight_holding'] != null){this.costDefaults.bdbl_overnight_holding = this.customer_costDefaults['bdbl_overnight_holding'];};
    if(this.customer_costDefaults['pallet_max_width'] != null){this.costDefaults.pallet_max_width = this.customer_costDefaults['pallet_max_width'];};
    if(this.customer_costDefaults['pallet_max_length'] != null){this.costDefaults.pallet_max_length = this.customer_costDefaults['pallet_max_length'];};
    if(this.customer_costDefaults['pallet_max_height'] != null){this.costDefaults.pallet_max_height = this.customer_costDefaults['pallet_max_height'];};
    if(this.customer_costDefaults['pallet_max_weight'] != null){this.costDefaults.pallet_max_weight = this.customer_costDefaults['pallet_max_weight'];};
    if(this.customer_costDefaults['hr_default_load_rate'] != null){this.costDefaults.hr_default_load_rate = this.customer_costDefaults['hr_default_load_rate'];};
    if(this.customer_costDefaults['semi_default_load_rate'] != null){this.costDefaults.semi_default_load_rate = this.customer_costDefaults['semi_default_load_rate'];};
    if(this.customer_costDefaults['bdbl_default_load_rate'] != null){this.costDefaults.bdbl_default_load_rate = this.customer_costDefaults['bdbl_default_load_rate'];};
    if(this.customer_costDefaults['cubic_weight_param'] != null){this.costDefaults.cubic_weight_param = this.customer_costDefaults['cubic_weight_param'];};
    

    if(this.customer_costDefaults['hr_waiting_time'] != null && this.customer_costDefaults['hr_waiting_time'] > 0){this.costDefaults.hr_waiting_time = this.customer_costDefaults['hr_waiting_time'];};
    if(this.customer_costDefaults['semi_waiting_time'] != null && this.customer_costDefaults['semi_waiting_time'] > 0){this.costDefaults.semi_waiting_time = this.customer_costDefaults['semi_waiting_time'];};
    if(this.customer_costDefaults['bdbl_waiting_time'] != null && this.customer_costDefaults['bdbl_waiting_time'] > 0){this.costDefaults.bdbl_waiting_time = this.customer_costDefaults['bdbl_waiting_time'];};
    
    this.hr_waiting_time = this.costDefaults.hr_waiting_time;
    this.semi_waiting_time = this.costDefaults.semi_waiting_time;
    this.bdbl_waiting_time = this.costDefaults.bdbl_waiting_time;
    
    setTimeout(() => {},300);
  }

  //this is to calculate demurrage time for activities given the duration time in minutes
  calculateDemurrageTime(duration_minutes, run_service_category_name){
    let total_demurrage_minutes = 0;
    switch(run_service_category_name){
      case 'HR': {
        total_demurrage_minutes = duration_minutes - this.hr_waiting_time;
        break;
      }
      case 'Semi': {
        total_demurrage_minutes = duration_minutes - this.semi_waiting_time;      
        break;
      } 
      case 'BDBL': {          
        total_demurrage_minutes = duration_minutes - this.bdbl_waiting_time;      
        break;
      } 
      case 'Road Train': {          
        total_demurrage_minutes = duration_minutes - this.bdbl_waiting_time;      
        break;
      } 
      default: {
        total_demurrage_minutes = 0;
        break;
      } 
    }
    
    let min_label = 'minute';
    if(total_demurrage_minutes > 1){
      min_label = 'minutes';
    };
    
    if(total_demurrage_minutes > 0){
      return '[Demurrage: ' + total_demurrage_minutes + ' ' + min_label + ']';
    }else{
      return '';}
  }

  // get the demurrage ceiling based on service category of the run
  getDemurrageCeiling(service_category_name){
    let ceiling_minutes = 0;
    switch(service_category_name){
      case 'HR': {
        ceiling_minutes = this.hr_waiting_time;   
        break;
      }
      case 'Semi': {
        ceiling_minutes = this.semi_waiting_time;      
        break;
      } 
      case 'BDBL': {          
        ceiling_minutes = this.bdbl_waiting_time;      
        break;
      }
      case 'Road Train': {          
        ceiling_minutes = this.bdbl_waiting_time;      
        break;
      } 
      default: {
        ceiling_minutes = 0;
        break;
      };
    }
    
    return ceiling_minutes;
  }
}